jQuery(document).ready(function () {
  /*jshint loopfunc: true */
  'use strict';

  const gallery = document.querySelectorAll('.gallery');

  if (gallery) {
    jQuery('.gallery').slick({
      autoplay: false,
      infinite: true,
      speed: 700,
      cssEase: 'ease',
      swipe: false,
      dots: true,
      arrows: true
    });
  }
});
